import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const PUT_STEDSBESKRIVELSE_URL = (stedbeskrivelseId) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/stedsbeskrivelser/${stedbeskrivelseId}`;
